/**
 * The order a universe picker lists its choices in: alphabetical by the name
 * shown (the owner, 2026-10-30: "When i want to select the universe, they
 * should be in alphabetical order"). Case is ignored and numbers compare by
 * value, so "NASDAQ 100" comes before "Nasdaq All Issues" and "S&P 500" before
 * "S&P 1500".
 *
 * A picker sorts at the point it draws; the shared lists (`SELECTABLE_UNIVERSE_SLUGS`,
 * `BREADTH_UNIVERSES`, ...) keep their own order, which other readers (the
 * worker's precompute, The Read's pooled indices) depend on. Pure: no imports,
 * so it adds nothing to a bundle but this function.
 */

export function compareUniverseNames(a: string, b: string): number {
  return a.localeCompare(b, "en", { sensitivity: "base", numeric: true });
}

/** `list` in a picker's order, by the name each item shows. */
export function byUniverseName<T>(list: readonly T[], nameOf: (item: T) => string): T[] {
  return [...list].sort((x, y) => compareUniverseNames(nameOf(x), nameOf(y)));
}

/** Choices of a study's `select` input, in a picker's order. */
export function choicesByName<T extends { label: string }>(choices: readonly T[]): T[] {
  return byUniverseName(choices, (c) => c.label);
}
